
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Component 26 – 5","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"data-name":"Rectangle 16412","width":"15","height":"15","fill":"none"}}),_c('g',{attrs:{"data-name":"Group 48364"}},[_c('g',{attrs:{"data-name":"Group 48365","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-width":"1.2","transform":"translate(1.922 3.711)"}},[_c('line',{attrs:{"data-name":"Line 1801","y2":"4.112","transform":"translate(11.156 1.734)"}}),_c('line',{attrs:{"data-name":"Line 1802","x1":"9.862","transform":"translate(1.135 3.79)"}}),_c('path',{attrs:{"data-name":"Path 37750","d":"M3.79 0L0 3.789 3.79 7.58","stroke-linejoin":"round"}})])])])
          )
        }
      }
    